import React from "react";
import { Responsive } from "react-admin";

import Work from "@material-ui/icons/Work";
import AccountBox from "@material-ui/icons/AccountBox";

import { getCompany } from "../common/utilities";
import { getLoggedUserFromToken, getUserCompany } from "../common/authClient";

class AppBarTitle extends React.Component {
    state = { company: null, company_id: getUserCompany() };

    componentDidMount() {
        getCompany(this.state.company_id).then(company =>
            this.setState({ company })
        );
    }

    render() {
        return (
            <div>
                <Responsive
                    small={
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <AccountBox />
                                    </td>
                                    <td>{getLoggedUserFromToken()}</td>
                                </tr>
                                <tr>
                                    <td>
                                        <Work />
                                    </td>
                                    <td>
                                        {this.state.company
                                            ? this.state.company.name
                                            : this.state.company_id}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    }
                    medium={
                        <span
                            style={{
                                position: "relative",
                                top: 4
                            }}
                        >
                            <AccountBox
                                // nativeColor="white"
                                style={{
                                    position: "relative",
                                    top: -3
                                }}
                            />{" "}
                            <span
                                style={{
                                    position: "relative",
                                    top: -6,
                                    fontSize: "medium"
                                }}
                            >
                                {getLoggedUserFromToken()}
                                {" / "}
                            </span>
                            <Work
                                // nativeColor="white"
                                style={{
                                    position: "relative",
                                    top: -3
                                }}
                            />{" "}
                            <span
                                style={{
                                    position: "relative",
                                    top: -6,
                                    fontSize: "medium"
                                }}
                            >
                                {this.state.company
                                    ? this.state.company.name
                                    : this.state.company_id}
                            </span>{" "}
                        </span>
                    }
                />
            </div>
        );
    }
}

export default AppBarTitle;



// WEBPACK FOOTER //
// ./src/components/AppBarTitle.js